import React, { FC, useEffect, useState } from 'react';
import classnames from 'classnames';
import s from './index.module.scss';
import CardNumber from './components/cardNumber';
import FormItem from './components/formItem';
import CardExpire from './components/cardExpire';
import CardCvc from './components/cardCvc';
import EmailField from './components/emailField';
import { extractEmailFromUrl } from '../../../../../../../../utils/scripts/extractEmailFromUrl';
import aes from 'crypto-js/aes';
import enc from 'crypto-js/enc-utf8';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../../store';

type Props = {
  className?: string;
  onCardCompleted?: (value: boolean, email: string) => void;
};

function getParameterFromURLForEmail(name) {
  let url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2]);
}

let emailInputValue;

if (window.userEmailValue) {
  emailInputValue = window.userEmailValue;
} else {
  let emailInputValueFromUrl = getParameterFromURLForEmail('ev');
  if (emailInputValueFromUrl) {
    let emailInputValueRaw = aes.decrypt(emailInputValueFromUrl, '9213812384');
    emailInputValue = emailInputValueRaw.toString(enc);
  } else {
    emailInputValue = extractEmailFromUrl();
  }
}

const PaymentCard: FC<Props> = props => {
  const { className, onCardCompleted } = props;
  const [numberComplete, setNumberComplete] = useState(false);
  const [expireComplete, setExpireComplete] = useState(false);
  const [cvcComplete, setCvcComplete] = useState(false);
  const emailValue = useSelector((state: RootState) => state.navigation.purchaseFlowScreen.email);
  const getInitialEmail = () => {
    if (emailValue) return emailValue;
    if (emailInputValue) return emailInputValue;
    return '';
  };

  const [email, setEmail] = useState(() => {
    const value = getInitialEmail();
    return {
      value,
      isValid: Boolean(value),
    };
  });
  
  useEffect(() => {
    onCardCompleted?.(
      numberComplete && expireComplete && cvcComplete && email.isValid,
      email.value
    );
  }, [numberComplete, expireComplete, cvcComplete, email.isValid, email.value]);

  return (
    <div className={classnames(s.paymentCard, className)}>
      <FormItem>
        <CardNumber onChange={e => setNumberComplete(e.complete)} />
      </FormItem>
      <div className={s.row}>
        <FormItem>
          <CardExpire onChange={e => setExpireComplete(e.complete)} />
        </FormItem>
        <FormItem>
          <CardCvc onChange={e => setCvcComplete(e.complete)} />
        </FormItem>
      </div>
      <FormItem>
        <EmailField
          defaultValue={email.value}
          onChange={(event, isValid) => setEmail({ value: event.target.value, isValid })}
        />
      </FormItem>
    </div>
  );
};

export default PaymentCard;
